import React from 'react';
import { columns } from './columns';
import { Table } from 'new/elements/Table';
import { useFlatFlows } from 'new/hooks/adapters/useFlatFlows';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';
import { PreviewFlowLeaf } from 'new/components/monitor/DataFlowStatus/PreviewFlowLeaf';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_PIPELINES_REQUEST } from 'js/constants/actionTypes';

interface FlowsTableProps {
  height?: number;
}

export function FlowsTable(props: FlowsTableProps) {
  const { height } = props;
  const { drawerContentRef } = useDrawerContext();
  const loading = useIsLoading(GET_PIPELINES_REQUEST);
  const flows = useFlatFlows();
  return (
    <Table
      loading={loading}
      parentScrollRef={!height ? drawerContentRef : undefined}
      height={height}
      rowCollapsibleRender={(row) => (
        <PreviewFlowLeaf {...row} height={200} fitViewOptions={{ padding: 0.5 }} />
      )}
      columns={columns}
      rows={flows}
    />
  );
}
